<script>
    let { text, returnBtn = false, actionBack } = $props();

    import { getMobileOS } from "@/utils/common";
    import { goTo } from "@/utils/router";
    import { onMount } from "svelte";

    let scrolling = $state(null);

    onMount(() => {
        window.addEventListener("scroll", () => {
            scrolling = window.scrollY > 20 ? true : null;
        });
    });
</script>

<!-- svelte-ignore a11y_consider_explicit_label -->
<div class="header --scrolling">
    <p class="header__title">{text}</p>
    {#if returnBtn}
        <button
            class="header__returnButton"
            onclick={() => goTo(`/${actionBack}`)}
        >
            <i class="icon fal fa-arrow-left"></i>
        </button>
    {/if}
    <h2 class="header__h2">{text}</h2>
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
